/******/ ;(() => {
  // webpackBootstrap
  var isDefined = customElements.get('localization-form')

  if (!isDefined) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super()

        this.elements = {
          input: this.querySelector(
            'input[name="language_code"],input[name="country_code"]',
          ),
          button: this.querySelector('button'),
          panel: this.querySelector('ul'),
        }

        // タッチデバイス対応のイベントリスナーを追加
        this.elements.button.addEventListener('click', (e) => {
          e.preventDefault()
          this.openSelector()
        })
        this.elements.button.addEventListener('touchend', (e) => {
          e.preventDefault()
          this.openSelector()
        })

        // blur処理の改善
        this.elements.button.addEventListener('blur', (e) =>
          this.closeSelector(e),
        )

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

        // クリックイベントの処理を改善
        this.querySelectorAll('a').forEach((item) => {
          item.addEventListener('click', (e) => this.onItemClick(e))
          item.addEventListener('touchend', (e) => {
            e.preventDefault()
            this.onItemClick(e)
          })
        })
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false')
        this.elements.panel.setAttribute('hidden', true)
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return
        this.hidePanel()
        this.elements.button.focus()
      }

      onItemClick(event) {
        event.preventDefault()
        event.stopPropagation() // イベントの伝播を停止

        const form = this.querySelector('form')
        if (!form || !this.elements.input) return

        this.elements.input.value = event.currentTarget.dataset.value

        // フォーム送信を非同期で実行
        setTimeout(() => {
          form.submit()
        }, 0)
      }

      openSelector() {
        const isExpanded =
          this.elements.button.getAttribute('aria-expanded') === 'true'
        this.elements.button.setAttribute(
          'aria-expanded',
          (!isExpanded).toString(),
        )
        this.elements.panel.toggleAttribute('hidden')
      }

      closeSelector(event) {
        if (
          !event.relatedTarget ||
          !event.relatedTarget.classList.contains('disclosure__item_el')
        ) {
          this.hidePanel()
        }
      }
    }

    customElements.define('localization-form', LocalizationForm)
  }
  /******/
})()
